const STORAGE_KEY = 'driver_tracking_shipment_id'

export function getTrackedShipmentId(): string | null {
  return localStorage.getItem(STORAGE_KEY)
}

export function setTrackedShipmentId(shipmentId: string): void {
  localStorage.setItem(STORAGE_KEY, shipmentId)
}

export function clearTrackedShipmentId(): void {
  localStorage.removeItem(STORAGE_KEY)
}
